module.exports = __webpack_public_path__ + "static/media/facebook-icon.5d5ecf18.svg";